import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';

import useFilters from './useFilters';
import getNewRoute from '../../containers/helpers';
import { getCategories } from './helpers';

const sortByCategoriesOrder = cats => (a, b) =>
  cats.findIndex(({ key }) => key === a[0]) -
  cats.findIndex(({ key }) => key === b[0]);

const FilterRow = ({ row, filters, index, removeVisualization, view }) => {
  const categories = getCategories(view);

  const [tmpRow, setRow] = useState(row);

  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = ({ currentTarget: { name, value } }) => {
    setRow(prevRow => {
      const nextRow = Object.fromEntries(
        Object.entries(prevRow).map(([filterKey, filterValue]) => [
          filterKey,
          filterValue === undefined ? row[filterKey] : filterValue,
        ]),
      );
      return { ...nextRow, [name]: Number(value) };
    });
  };

  const handleDateChange = value => {
    setRow(prevRow => ({
      ...prevRow,
      dates: value.toISOString().split('T')[0],
    }));
  };

  const timeSeriesFilters = useFilters(tmpRow, view);

  const isLoading = timeSeriesFilters.some(item => item.isLoading);
  const [currentFilters] = timeSeriesFilters
    .map(({ data }) => data)
    .filter(Boolean);

  useEffect(() => {
    if (!isLoading) {
      const nextFilters = filters.map((filter, i) => {
        if (index !== i) {
          return filter;
        }
        return Object.entries(currentFilters)
          .sort(sortByCategoriesOrder(categories))
          .reduce((list, [key, value]) => {
            list[key] = value.default?.id;
            return list;
          }, {});
      });
      if (JSON.stringify(filters) !== JSON.stringify(nextFilters)) {
        navigate(getNewRoute(location, { activeFilters: nextFilters }));
      }
    }
  }, [
    categories,
    currentFilters,
    filters,
    index,
    isLoading,
    location,
    navigate,
    timeSeriesFilters,
    tmpRow,
  ]);

  return (
    <tr className="Filters">
      {removeVisualization && filters.length > 1 && (
        <td>
          <button
            type="button"
            onClick={() => removeVisualization(index)}
            className="filters2-button remove-button2"
            aria-label="Remove filter row"
          >
            -
          </button>
        </td>
      )}
      {timeSeriesFilters.map(item => {
        if (item.isLoading) {
          return categories.map(category => (
            <td key={category.key}>
              <span className="loadingFilter">Loading</span>
            </td>
          ));
        }
        if (item.data) {
          return Object.entries(item.data)
            .sort(sortByCategoriesOrder(categories))
            .filter(([key]) =>
              categories.some(category => category.key === key),
            )
            .map(([key, value]) => (
              <td
                className={key !== 'dates' ? 'moniqua-select' : ''}
                key={`${key}-${JSON.stringify(value.values)}`}
              >
                {key !== 'dates' && value.values.length > 0 && (
                  <select
                    id={`filter-${key}`}
                    name={key}
                    defaultValue={value.default?.id ?? null}
                    onChange={handleChange}
                  >
                    {value.values.map(({ depth, name = depth, id }) => (
                      <option key={id} value={id}>
                        {name ?? depth}
                      </option>
                    ))}
                  </select>
                )}
                {key === 'dates' && value.values.length > 0 && (
                  <DatePicker
                    className="moniqua-select date"
                    selected={new Date(value.default.id)}
                    dateFormat="yyyy-MM-dd"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    minDate={
                      new Date(value.values[value.values.length - 1].name)
                    }
                    maxDate={new Date(value.values[0].name)}
                    onChange={handleDateChange}
                    includeDates={value.values.map(({ id }) => new Date(id))}
                  />
                )}
                {value.values.length === 0 && <>__</>}
              </td>
            ));
        }
        return null;
      })}
    </tr>
  );
};

export default FilterRow;
